'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultSubtitle = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _ = require('../');
var _constants = require('../constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getDefaultSubtitle = exports.getDefaultSubtitle = function getDefaultSubtitle(_ref) {
  var customAttributes = _ref.customAttributes,
    dimensions = _ref.dimensions,
    display = _ref.display,
    units = _ref.units;
  var _display = (0, _.parseDisplay)(display);
  var formatter = (0, _.dimensionValueDisplay)(_display);
  var _getFlags = (0, _.getFlags)(customAttributes, formatter, {});
  var unitsValuesIds = R.pipe(R.propOr([], 'values'), R.pluck('id'))(units);
  return R.pipe(R.propOr([], 'one'), R.values, R.sortBy(R.prop('__index')), R.reduce(function (acc, dim) {
    if (!R.propOr(true, 'display', dim)) {
      return acc;
    }
    if (R.includes(dim.id, unitsValuesIds)) {
      return acc;
    }
    var value = R.path(['values', 0], dim);
    if (R.includes(value.id, _constants.DEFAULT_REJECTED_SUBTITLE_IDS) || !R.propOr(true, 'display', value)) {
      return acc;
    }
    var flags = _getFlags({
      attributes: R.propOr({}, 'attributes', value),
      notes: R.propOr([], 'notes', value)
    });
    return R.append({
      header: formatter(dim) + ':',
      label: formatter(value),
      flags: flags
    }, acc);
  }, []))(dimensions);
};